import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  let raf = requestAnimationFrame(function loop(t) {
    lenis.raf(t);
    raf = requestAnimationFrame(loop);
  });
  return () => {
    cancelAnimationFrame(raf);
    lenis.destroy();
    lenis = null;
  };
}

export function scrollToId(id) {
  const el = document.querySelector(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -76, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function goToTab(tab) {
  window.dispatchEvent(new CustomEvent("tk:tab", { detail: tab }));
}
